import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './helpers/createBaseQuery';
import { IApplicationContext } from '../types/applicationContext';
import {
  fetchGetAvailableMultiOffers,
  TGetAvailableMultiOffersRequest as TGetAvailableMultiOffersRequestSchema,
  TGetAvailableMultiOffersResponse_1 as TGetAvailableMultiOffersResponse_1Schema,
} from 'shared/repositories/mortgage-broker-calculator/v1/get-available-multi-offers';

export type TLandingApiEndpoits = keyof typeof landingApi.endpoints;
export let landingApi: ReturnType<typeof createLandingApi>;

export const createLandingApi = (ctx: IApplicationContext) => {
  const newApi = createApi({
    reducerPath: 'landingApi',
    baseQuery: createBaseQuery(ctx),
    endpoints: builder => ({
      getOfferListing: builder.query<TGetAvailableMultiOffersResponse_1Schema, TGetAvailableMultiOffersRequestSchema>({
        query: parameters => ({
          parameters,
          fetchFunction: fetchGetAvailableMultiOffers,
          loggerInfo: {
            description: 'Получение данных для листинга',
            degradation: 'Отображение критической ошибки, листинг недоступен',
          },
        }),
      }),
    }),
  });

  landingApi = newApi;

  return newApi;
};
